import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function usePlaceVaultInGroup() {
  const queryClient = useQueryClient()

  const action = async ({ vaultId, groupId, sortOrder }) => {
    const response = await httpClient.post(
      `/team/vault/${vaultId}/place-in-group`,
      {
        group_id: groupId,
      },
    )

    await httpClient.put(`team/vault/sort-order`, {
      id: vaultId,
      entity_type: 'vaults',
      sort_order: sortOrder,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
